export default {
  DIALOGS_TOP_INDENT: 25,
  DESKTOP_BREAKPOINT: '1024px',
  SHOW_DIFM_BUTTON_BREAKPOINT: '1280px',
};
